import { Box, type SxProps, type Theme } from "@mui/material";

import { mergeSxProps } from "../../lib";

export interface RadioIndicatorProps {
  selected: boolean;
  sx?: SxProps<Theme>;
}

export function RadioIndicator(props: RadioIndicatorProps) {
  const { selected, sx } = props;

  return (
    <Box
      data-testid={`radio-indicator-${selected ? "selected" : "unselected"}`}
      sx={mergeSxProps(
        (theme) => ({
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: theme.spacing(7),
          height: theme.spacing(7),
          borderRadius: theme.spacing(7),
          borderWidth: theme.borderWidth?.regular,
          borderStyle: "solid",
          borderColor: selected ? theme.palette.primary.main : theme.palette.border?.primary,
          transition: theme.transitions.create(["border-color"], {
            duration: theme.transitions.duration.standard,
          }),
        }),
        sx
      )}
    >
      <Box
        sx={(theme) => ({
          opacity: selected ? 1 : 0,
          width: theme.spacing(4),
          height: theme.spacing(4),
          borderRadius: theme.spacing(4),
          backgroundColor: theme.palette.primary.main,
          transition: theme.transitions.create(["opacity"], {
            duration: theme.transitions.duration.standard,
          }),
        })}
      />
    </Box>
  );
}
